import { styled } from "styled-components";
import BackgroundImage from "../../../assets/images/second-card-background.svg";

export const SuggestionContainer = styled.a`
	background-image: url(${BackgroundImage});
	background-size: cover;
`;
